import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../lib/theme';

export default function ThemeToggle({ compact = false }) {
    const { theme, toggleTheme } = useTheme();
    const isDark = theme === 'dark';

    return (
        <button
            type="button"
            onClick={toggleTheme}
            data-testid="theme-toggle-btn"
            title={isDark ? 'Passa al tema chiaro' : 'Passa al tema scuro'}
            className={`flex items-center justify-center border border-white/20 hover:border-[#00FF41]/50 transition-colors ${
                compact ? 'w-9 h-9' : 'px-3 py-2 gap-2'
            }`}
        >
            {isDark ? (
                <Sun className="w-4 h-4 text-[#00FF41]" />
            ) : (
                <Moon className="w-4 h-4 text-[#00FF41]" />
            )}
            {!compact && (
                <span className="text-xs font-mono uppercase text-white">
                    {isDark ? 'Chiaro' : 'Scuro'}
                </span>
            )}
        </button>
    );
}
